module.exports = __webpack_public_path__ + "img/GAME_OMOK1.a2a6fa23.jpg";